import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmailSignature from './EmailSignature';
import EmptySpace from '../modules/EmptySpace';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class BanStatusServiceStatusBanned extends React.Component {


    render() {
        const { content: { userName, adminMail, logo, siteName } } = this.props;
        let mailTo = 'mailto:' + adminMail;

        return (
            <Layout>
                <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
                <div style={body}>
                    <div style={fontWeightBold}>
                        Hi {userName},
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        We regret to inform you that your account has been disabled due to a violation of our platform’s terms and conditions. Maintaining a safe and respectful environment for all users is our top priority.
                    </div>
                    <EmptySpace height={20} />
                    <div>
                        If you have any questions, feel free to reach out to our <a href={mailTo} style={linkText}>support team</a>.
                    </div>
                    <EmptySpace height={20} />
                    <EmailSignature siteName={siteName} />
                </div>
                <EmptySpace height={40} />
                <Footer siteName={siteName} />
                <EmptySpace height={20} />
            </Layout>
        );
    }

}

export default BanStatusServiceStatusBanned;